import axios from 'axios';
import store from './store';
import router from './router';
import authService from './services/auth.service'

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: true
});

//  응답에서 401 처리 (로그아웃 및 리디렉션)
api.interceptors.response.use(
    res => res,
    async err => {
        const originalRequest = err.config;

        if (err.response?.status === 403) {
            store.dispatch('auth/logout');
            router.push('/login');
            return Promise.reject(err);
        }

        if (
            err.response?.status === 401 &&
            !originalRequest._retry 
            && !originalRequest.url.includes('auth/refresh')
        ) {
            originalRequest._retry = true;
            //console.log('interceptors')
            try {
                const refreshResponse = await authService.refreshToken();                
                const newAccessToken = refreshResponse.data.accessToken;                

                //store.state.auth.user.accessToken = newAccessToken;


                originalRequest.headers = originalRequest.headers || {};                
                originalRequest.headers['x-access-token'] = newAccessToken;

                //console.log(originalRequest.headers)

                return await api(originalRequest); // 재요청
            } catch (refreshErr) {
                //console.log(refreshErr)
                store.dispatch('auth/logout');
                router.push('/login');
                return Promise.reject(refreshErr);
            }
        }

        return Promise.reject(err);
    }
);

export default api;